var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.sound},[_c('div',{class:[
      _vm.$style['sound__wave'],
      _vm.audioPlay ? _vm.$style['sound__wave--play'] : _vm.$style['sound__wave--paused'] ],on:{"click":function($event){_vm.toggleAudio()}}},[_c('canvas',{ref:"canvas"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c14382","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sound.vue
// module id = null
// module chunks = 